let authorizedRouteCount = 0;

export const routeAccess = {
  enter(): void {
    authorizedRouteCount += 1;
  },
  leave(): void {
    authorizedRouteCount = Math.max(0, authorizedRouteCount - 1);
  },
  isAuthorized(): boolean {
    return authorizedRouteCount > 0;
  },
};
